module.exports = __webpack_public_path__ + "static/media/10.03fa98fa.gif";